var React = require('react');

function Shape (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;opacity:0.1;}")),React.createElement("g",{"id":"Warstwa_2","data-name":"Warstwa 2","key":1},React.createElement("g",{"id":"Warstwa_1-2","data-name":"Warstwa 1"},React.createElement("path",{"className":"cls-1","d":"M633.52,847H302.27A136.64,136.64,0,0,1,183.93,778.7L18.31,491.83a136.63,136.63,0,0,1,0-136.64L183.93,68.32A136.64,136.64,0,0,1,302.27,0H633.52A136.64,136.64,0,0,1,751.85,68.32L917.48,355.19a136.68,136.68,0,0,1,0,136.64L751.85,778.7A136.64,136.64,0,0,1,633.52,847Z"})))]);
}

Shape.defaultProps = {"viewBox":"0 0 935.78 847.02"};

module.exports = Shape;

Shape.default = Shape;
